import React, { useEffect } from "react";
import DistributorBalance from "../../../ResuableCompoment/DistributorBalance";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ImageCarousel from "../../../ResuableCompoment/ImageCarousel";


const MasterDistributorDasboard = () => {

    const navvigate = useNavigate();
    const rolebased = useSelector((state) => state.auth.employeeDetails?.role);

    useEffect(() => {
        if (rolebased !== "MASTER_DISTRIBUTOR") {
            navvigate("/");
        }
    }, [])

    return (
        <div className="min-h-screen bg-slate-50">
            <DistributorBalance />

            <div className="mt-8 sm:mt-10 md:mt-12 mb-8">
                <ImageCarousel />
            </div>

        </div>
    );
};

export default MasterDistributorDasboard;
